import { ChapterItem } from "@/types/chapter";

export const chaptersData: ChapterItem[] = [
  {
    id: "chap-01",
    chapterNumber: "CHAPTER 01",
    titleSolid: "PREMIUM",
    titleOutline: "FURNITURE",
    description:
      "Every creation begins with skilled hands. Premium materials are transformed into handcrafted furniture designed for timeless comfort, beauty, and lasting elegance.",
    videoUrl: "/videos/metalv2.mp4",
    layoutSide: "left",
  },
  {
    id: "chap-02",
    chapterNumber: "CHAPTER 02",
    titleSolid: "IRON &",
    titleOutline: "ALUMINIUM",
    description:
      "Driven by precision casting, molten iron and aluminium are shaped into exceptional décor and furniture with unmatched strength, detail, and flawless craftsmanship.",
    videoUrl: "/videos/iron-cast.mp4",
    layoutSide: "right",
  },
  {
    id: "chap-03",
    chapterNumber: "CHAPTER 03",
    titleSolid: "NATURAL",
    titleOutline: "MARBLE",
    description:
      "Finished through expert polishing, every marble masterpiece reveals timeless elegance, unique natural patterns, and craftsmanship perfected across generations.",
    videoUrl: "/videos/marblev2.mp4",
    layoutSide: "left",
  },
  {
    id: "chap-04",
    chapterNumber: "CHAPTER 04",
    titleSolid: "ALUMINIUM",
    titleOutline: "CASTING",
    description:
      "Lightweight yet remarkably strong, aluminium is precision-cast into refined furniture and architectural pieces, combining durability, intricate detail, and contemporary elegance.",
    videoUrl: "/videos/aluminium-casting.mp4",
    layoutSide: "right",
  },
  {
    id: "chap-05",
    chapterNumber: "CHAPTER 05",
    titleSolid: "BRASS",
    titleOutline: "CASTING",
    description:
      "Through meticulous brass casting and finishing, each piece captures warmth, character, and intricate detail, creating timeless furniture and décor with a distinctive handcrafted presence.",
    videoUrl: "/videos/brass-casting.mp4",
    layoutSide: "left",
  },
];
